import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SectionHeader from '../molecules/SectionHeader';
import AgentList from '../molecules/AgentList';
import MainLayout from '../../Layouts/MainLayout';
import axios from '../../../config/axios';
import { Crew } from '../types/Crew.types';
import { format, parseISO } from 'date-fns'; 
import { service } from '../../../services/AxiosServices';
import AccessControl from '../molecules/AccessControl';
import AccessDenied from '../atoms/AccessDenied';
import useAccessCheckLoading from '../../../utils/useAccessCheckLoading';
import Spinner from '../atoms/Spinner';

interface Agent {
  id: string;
  name: string;
  updatedOn: string;
  createdBy: string;
  usedLLM: string;
}

interface CrewNameProps {
  crewName?: string;
  crewId: string;
}




const AgentInfo: React.FC<CrewNameProps> = ({ crewName, crewId }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [agents, setAgents] = useState<Agent[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const accessCheckLoading = useAccessCheckLoading()
  useEffect(() => {
    const fetchAgent = async () => {
      try {
        setLoading(true);
      
        const response = await  service<{agents:any}>(
          'api/get-all-agents/',
          'post',
          { crew_id: crewId },
         
        );
     
        const fetchedAgents = response.data.agents.map((agent: any, index: number) => ({
          id: agent.id,
          name: agent.agent_name || `Agent`,
          updatedOn: format(parseISO(agent.updated_at), 'dd-MM-yyyy, HH:mm'),
          createdBy: 'Admin',
          usedLLM: 'Claude 3.5 Sonnet',
        })).sort((a:any, b:any) => a.id - b.id)


        setAgents(fetchedAgents);
      } catch (err) {
        // console.log('Error fetching agents:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAgent();
  }, [crewId]);

  const handleAdd = (): void => {
    navigate(`/add_agent/${id}`, { state: { crewName } });
  };
  const handleDeleteAgent = (id: number) => {
    setAgents((prevAgents) => prevAgents.filter((agent) =>Number(agent.id) !== id));
  }
  return (
    <>
    <AccessControl
    requiredPermissions={[
          {
            permission: "manage_agents",
            types: ["read"],
          },
        ]}
        renderNoAccess={ accessCheckLoading ? <Spinner/> :<AccessDenied />}
      >
    <SectionHeader
    back={true}
    title={`Agents of ${crewName?.toLowerCase()} crew`}
    onAdd={handleAdd}
    action="Create"
    permissionName={
       'manage_agents'
    }
    permissionTypes={['create']}
    link={`/add_agent/${id}`}

  />
    
      <AgentList 
        agents={agents}
        crewName={crewName} 
        loading={loading}
        crewId={crewId}
        onDelete = {handleDeleteAgent}
       
        />
        </AccessControl>
    </>
  );
};

export default AgentInfo;
